module.exports = __webpack_public_path__ + "static/img/m_6.23063d38.jpg";